<template>
    <AppLayout>
        <div class="certificate-container">
            <!-- Certificate Actions Bar -->
            <div class="certificate-actions mb-4">
                <div class="d-flex justify-content-between align-items-center">
                    <h2 class="mb-0">
                        <i class="bi bi-award-fill text-warning me-2"></i>
                        Professional Certificate
                    </h2>
                    <div class="action-buttons">
                        <button class="btn btn-outline-primary btn-sm me-2">
                            <i class="bi bi-download me-1"></i>
                            Download PDF
                        </button>
                        <button class="btn btn-outline-success btn-sm me-2">
                            <i class="bi bi-share me-1"></i>
                            Share
                        </button>
                        <button class="btn btn-outline-info btn-sm">
                            <i class="bi bi-printer me-1"></i>
                            Print
                        </button>
                    </div>
                </div>
            </div>

            <!-- Certificate Display -->
            <div class="certificate-wrapper">
                <div class="certificate" id="certificate">
                    <!-- Certificate Header -->
                    <div class="certificate-header">
                        <div class="certificate-logo">
                            <div class="logo-circle">
                                <i class="bi bi-shield-fill-check"></i>
                            </div>
                        </div>
                        <h1 class="institute-name">Institute of Cybersecurity and Data Governance Professionals</h1>
                        <div class="certificate-subtitle">Professional Certification Program</div>
                    </div>

                    <!-- Certificate Body -->
                    <div class="certificate-body">
                        <div class="certificate-title">
                            Certificate of Professional Achievement
                        </div>

                        <div class="certificate-text">
                            <p class="presentation-text">This is to certify that</p>

                            <div class="recipient-name">Terry Mukamuri</div>

                            <p class="accomplishment-text">
                                has successfully completed the requirements for
                            </p>

                            <div class="certification-name">
                                Certified Information Security Professional (CISP)
                            </div>

                            <p class="completion-text">
                                and has demonstrated exceptional competency in cybersecurity frameworks,
                                risk management, and data governance principles as outlined by industry standards.
                            </p>
                        </div>

                        <!-- Certificate Details -->
                        <div class="certificate-details">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="detail-item">
                                        <strong>Certificate ID:</strong><br>
                                        <span class="detail-value">ICDGP-2025-CISP-001947</span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="detail-item">
                                        <strong>Issue Date:</strong><br>
                                        <span class="detail-value">September 19, 2025</span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="detail-item">
                                        <strong>Valid Until:</strong><br>
                                        <span class="detail-value">September 19, 2028</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Certificate Footer -->
                    <div class="certificate-footer">
                        <div class="row align-items-end">
                            <div class="col-md-4">
                                <div class="signature-section">
                                    <div class="signature-line"></div>
                                    <div class="signature-title">Dr. Sarah Mitchell</div>
                                    <div class="signature-role">Director of Certification</div>
                                </div>
                            </div>
                            <div class="col-md-4 text-center">
                                <div class="certificate-seal">
                                    <div class="seal-outer">
                                        <div class="seal-inner">
                                            <i class="bi bi-patch-check-fill"></i>
                                            <div class="seal-text">VERIFIED</div>
                                            <div class="seal-year">2025</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <div class="signature-section">
                                    <div class="signature-line"></div>
                                    <div class="signature-title">Prof. James Anderson</div>
                                    <div class="signature-role">Chief Executive Officer</div>
                                </div>
                            </div>
                        </div>

                        <!-- Verification Footer -->
                        <div class="verification-footer">
                            <div class="verification-text">
                                <small>
                                    <i class="bi bi-check-circle-fill text-success me-1"></i>
                                    This certificate can be verified online at:
                                    <strong>verify.icdgp.org/ICDGP-2025-CISP-001947</strong>
                                </small>
                            </div>
                        </div>
                    </div>

                    <!-- Certificate Border Decorations -->
                    <div class="certificate-border">
                        <div class="border-corner border-top-left"></div>
                        <div class="border-corner border-top-right"></div>
                        <div class="border-corner border-bottom-left"></div>
                        <div class="border-corner border-bottom-right"></div>
                    </div>
                </div>
            </div>

            <!-- Certificate Information -->
            <div class="certificate-info mt-4 d-none">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="mb-0">
                                    <i class="bi bi-info-circle me-2"></i>
                                    Certificate Information
                                </h5>
                            </div>
                            <div class="card-body">
                                <div class="info-grid">
                                    <div class="info-item">
                                        <strong>Program Duration:</strong>
                                        <span>6 Months Intensive Training</span>
                                    </div>
                                    <div class="info-item">
                                        <strong>Training Hours:</strong>
                                        <span>240 Hours</span>
                                    </div>
                                    <div class="info-item">
                                        <strong>Assessment Score:</strong>
                                        <span class="text-success">92/100 (Distinction)</span>
                                    </div>
                                    <div class="info-item">
                                        <strong>Practical Projects:</strong>
                                        <span>5 Real-world Case Studies</span>
                                    </div>
                                    <div class="info-item">
                                        <strong>CPD Credits:</strong>
                                        <span>45 Credits Earned</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="mb-0">
                                    <i class="bi bi-check2-square me-2"></i>
                                    Core Competencies Achieved
                                </h5>
                            </div>
                            <div class="card-body">
                                <div class="competencies-list">
                                    <div class="competency-item">
                                        <i class="bi bi-check-circle-fill text-success me-2"></i>
                                        Risk Assessment & Management
                                    </div>
                                    <div class="competency-item">
                                        <i class="bi bi-check-circle-fill text-success me-2"></i>
                                        Security Framework Implementation
                                    </div>
                                    <div class="competency-item">
                                        <i class="bi bi-check-circle-fill text-success me-2"></i>
                                        Data Governance & Compliance
                                    </div>
                                    <div class="competency-item">
                                        <i class="bi bi-check-circle-fill text-success me-2"></i>
                                        Incident Response Planning
                                    </div>
                                    <div class="competency-item">
                                        <i class="bi bi-check-circle-fill text-success me-2"></i>
                                        Security Audit & Assessment
                                    </div>
                                    <div class="competency-item">
                                        <i class="bi bi-check-circle-fill text-success me-2"></i>
                                        Privacy & Data Protection
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '../Layouts/AppLayout.vue';
</script>

<style scoped>
/* Certificate Container */
.certificate-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
    background-color: #f8f9fa;
    min-height: 100vh;
}

/* Certificate Actions */
.certificate-actions {
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.action-buttons .btn {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.action-buttons .btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Certificate Wrapper */
.certificate-wrapper {
    display: flex;
    justify-content: center;
    padding: 2rem 0;
}

/* Main Certificate Styling */
.certificate {
    width: 100%;
    max-width: 900px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border: 3px solid #2c3e50;
    border-radius: 15px;
    padding: 3rem;
    position: relative;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    font-family: 'Fira Sans', serif;
    overflow: hidden;
}

.certificate::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.03) 0%, transparent 50%);
    pointer-events: none;
}

/* Certificate Header */
.certificate-header {
    text-align: center;
    margin-bottom: 2.5rem;
    position: relative;
    z-index: 2;
}

.certificate-logo .logo-circle {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
    color: white;
    font-size: 2rem;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.institute-name {
    font-size: 2rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 0.5rem;
    letter-spacing: 1px;
}

.certificate-subtitle {
    font-size: 1.1rem;
    color: #7f8c8d;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 2px;
}

/* Certificate Body */
.certificate-body {
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    z-index: 2;
}

.certificate-title {
    font-size: 2.5rem;
    font-weight: 300;
    color: #2c3e50;
    margin-bottom: 2rem;
    letter-spacing: 1px;
    text-transform: uppercase;
}

.presentation-text {
    font-size: 1.2rem;
    color: #7f8c8d;
    margin-bottom: 1rem;
    font-style: italic;
}

.recipient-name {
    font-size: 3rem;
    font-weight: 700;
    color: #667eea;
    margin: 1.5rem 0;
    text-decoration: underline;
    text-decoration-color: #764ba2;
    text-decoration-thickness: 3px;
    text-underline-offset: 8px;
}

.accomplishment-text {
    font-size: 1.2rem;
    color: #7f8c8d;
    margin: 1.5rem 0;
    font-style: italic;
}

.certification-name {
    font-size: 2rem;
    font-weight: 600;
    color: #e74c3c;
    margin: 1.5rem 0;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.completion-text {
    font-size: 1rem;
    color: #7f8c8d;
    line-height: 1.6;
    max-width: 700px;
    margin: 1.5rem auto;
}

/* Certificate Details */
.certificate-details {
    margin: 2rem 0;
    padding: 1.5rem;
    background: rgba(102, 126, 234, 0.05);
    border-radius: 10px;
    border: 1px solid rgba(102, 126, 234, 0.1);
}

.detail-item {
    text-align: center;
    padding: 0.5rem;
}

.detail-item strong {
    color: #2c3e50;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.detail-value {
    color: #667eea;
    font-weight: 600;
    font-size: 1rem;
}

/* Certificate Footer */
.certificate-footer {
    margin-top: 3rem;
    position: relative;
    z-index: 2;
}

.signature-section {
    text-align: center;
}

.signature-line {
    width: 200px;
    height: 2px;
    background: #2c3e50;
    margin: 0 auto 0.5rem;
}

.signature-title {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 0.25rem;
}

.signature-role {
    color: #7f8c8d;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 1px;
}

/* Certificate Seal */
.certificate-seal {
    margin: 2rem 0;
}

.seal-outer {
    width: 120px;
    height: 120px;
    border: 4px solid #e74c3c;
    border-radius: 50%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(circle, #fff 0%, #f8f9fa 100%);
    box-shadow: 0 0 20px rgba(231, 76, 60, 0.3);
}

.seal-inner {
    text-align: center;
    color: #e74c3c;
}

.seal-inner i {
    font-size: 2.5rem;
    margin-bottom: 0.25rem;
}

.seal-text {
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.seal-year {
    font-size: 0.7rem;
    font-weight: 500;
}

/* Verification Footer */
.verification-footer {
    text-align: center;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 2px solid #ecf0f1;
}

.verification-text {
    color: #7f8c8d;
    font-size: 0.9rem;
}

.verification-text strong {
    color: #27ae60;
    font-family: 'Courier New', monospace;
}

/* Certificate Border Decorations */
.certificate-border {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
}

.border-corner {
    position: absolute;
    width: 60px;
    height: 60px;
    border: 3px solid;
    border-image: linear-gradient(135deg, #667eea, #764ba2) 1;
}

.border-top-left {
    top: 20px;
    left: 20px;
    border-right: none;
    border-bottom: none;
    border-top-left-radius: 15px;
}

.border-top-right {
    top: 20px;
    right: 20px;
    border-left: none;
    border-bottom: none;
    border-top-right-radius: 15px;
}

.border-bottom-left {
    bottom: 20px;
    left: 20px;
    border-right: none;
    border-top: none;
    border-bottom-left-radius: 15px;
}

.border-bottom-right {
    bottom: 20px;
    right: 20px;
    border-left: none;
    border-top: none;
    border-bottom-right-radius: 15px;
}

/* Certificate Info Cards */
.certificate-info .card {
    border: 1px solid #e9ecef;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.certificate-info .card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.certificate-info .card-header {
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: white;
    border-radius: 12px 12px 0 0 !important;
    border: none;
}

.info-grid {
    display: grid;
    gap: 1rem;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
    border-bottom: none;
}

.info-item strong {
    color: #2c3e50;
    font-weight: 500;
}

.info-item span {
    color: #7f8c8d;
    font-weight: 500;
}

.competencies-list {
    display: grid;
    gap: 0.75rem;
}

.competency-item {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #2c3e50;
}

/* Responsive Design */
@media (max-width: 768px) {
    .certificate-container {
        padding: 1rem;
    }

    .certificate {
        padding: 2rem 1.5rem;
    }

    .institute-name {
        font-size: 1.5rem;
    }

    .certificate-title {
        font-size: 2rem;
    }

    .recipient-name {
        font-size: 2.5rem;
    }

    .certification-name {
        font-size: 1.5rem;
    }

    .signature-line {
        width: 150px;
    }

    .action-buttons {
        flex-direction: column;
        gap: 0.5rem;
    }

    .action-buttons .btn {
        width: 100%;
    }
}

/* Print Styles */
@media print {

    .certificate-actions,
    .certificate-info {
        display: none !important;
    }

    .certificate-container {
        background: white !important;
        padding: 0 !important;
    }

    .certificate {
        box-shadow: none !important;
        border: 2px solid #2c3e50 !important;
        max-width: 100% !important;
        margin: 0 !important;
    }
}
</style>
